export default "__VITE_ASSET__yKgkIDcT__"